import React, { forwardRef } from 'react'
import { useIntl } from 'react-intl'
import { View, ViewStyle } from 'react-native'

import { useTheme } from 'styled-components/native'

import { ArrowIcon, ArrowIconDirection, PrimaryIconButton, SecondaryIconButton, SecondaryTertiaryIconButton } from '..'
import { tID } from '../../utils'
import { BaseButton, BaseButtonProps, ButtonSize, ButtonType } from '../baseButton/BaseButton'
import TertiaryIconButton from '../tertiaryIconButton/TertiaryIconButton'

export enum BackButtonV2Type {
  OATMEAL,
  WHITE,
}
export interface BackButtonV2Props {
  onPress: () => void
  backButtonType?: BackButtonV2Type
  testID?: string
  size?: ButtonSize
  isSecondaryButton?: boolean
  style?: ViewStyle
}

export const BackButtonV2 = forwardRef<React.ElementRef<typeof View>, BackButtonV2Props>(
  (
    { backButtonType, testID = tID('BackButton'), onPress, size = ButtonSize.DEFAULT, isSecondaryButton, style },
    ref,
  ) => {
    const { formatMessage } = useIntl()
    const { isAuroraTheme } = useTheme()

    const accessibilityLabel = formatMessage({
      defaultMessage: 'Go back',
      description: 'Screen reader text informing the user this button navigates them to the previous page',
    })

    const backButtonProps: BaseButtonProps = {
      accessibilityLabel: accessibilityLabel,
      leftIcon: <ArrowIcon direction={ArrowIconDirection.LEFT} />,
      onPress,
      testID,
      size,
      style,
    }

    if (isAuroraTheme) {
      if (isSecondaryButton) {
        return <SecondaryIconButton ref={ref} {...backButtonProps} />
      }
      return <PrimaryIconButton ref={ref} {...backButtonProps} />
    }

    if (backButtonType === BackButtonV2Type.WHITE) {
      return <BaseButton ref={ref} buttonType={ButtonType.WHITE_ICON} {...backButtonProps} />
    } else if (backButtonType === BackButtonV2Type.OATMEAL) {
      return <SecondaryTertiaryIconButton ref={ref} {...backButtonProps} />
    } else {
      return <TertiaryIconButton ref={ref} {...backButtonProps} />
    }
  },
)
